<template>
    <div class="holdingsPieChart">
        <apexchart :width="chartWidth" :options="options" :series="series"></apexchart>
    </div>
</template>

<script>
export default {
    props: {
        positions: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            series: [],
            options: {
                chart: {
                    type: 'pie',
                    height: '500'
                },
                labels: [],
                colors: [
                    "#FFD700", // Or
                    "#C0C0C0", // Argent (neutre)
                    "#CD7F32", // Bronze (neutre)
                    "#2F52E0", // Bleu royal (primaire)
                    "#D72638", // Rouge vif (primaire)
                    "#8E44AD", // Violet saturé (secondaire)
                    "#388E3C", // Vert émeraude (secondaire)
                    "#e6620a", // Orange profond (secondaire)
                    "#FF69B4", // Rose (tertiaire)
                    "#000000", // Noir (neutre)
                    "#1982C4", // Bleu clair profond (tertiaire)
                    "#A1C349", // Vert chartreuse (tertiaire)
                    "#D6BA8A", // Beige (tertiaire)
                    "#EB5E28", // Rouge orangé (tertiaire)
                    "#5A189A", // Indigo (tertiaire)
                    "#17BEBB" // Turquoise (tertiaire)
                ],
                legend: {
                    position: this.$vuetify.breakpoint.smAndDown ? 'bottom' : 'right'
                }
            }
        }
    },
    computed: {
        chartWidth() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return '100%';
                case 'sm':
                    return '400';
                case 'md':
                    return '500';
                case 'lg':
                    return '600';
                case 'xl':
                    return '700';
                default:
                    return '100%';
            }
        }
    },
    mounted() {
        this.positions
        .sort((a, b) => {
            return b.percentageOfAllInvestment - a.percentageOfAllInvestment;
        })
        .forEach(position => {
            this.series.push(position.percentageOfAllInvestment)
            let valuePart = "";
            if (position.stockValue !== undefined && Number.isFinite(position.stockValue)) {
                const value = parseFloat(position.stockValue).toFixed(2);
                valuePart = `$ ${value}`;
            }
            this.options.labels.push(`<div style='font-weight: bold;width: 80px;'>${position.stockSymbol}</div><div style='text-align: right;width: 80px;'>${valuePart}</div>`);
        });
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/breakpoints.scss";
.holdingsPieChart {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    .pieLabel {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .pieLabelSymbol {
            font-weight: bold;
            font-size: 1em;
            color: #333;
        }
        .pieLabelValue {
            text-align: right;
            font-size: 0.9em;
            color: #666;
        }
    }
    ::v-deep div.apexcharts-legend-series {
        display: flex;
        align-items: center;
        gap: 5px;
        padding: 5px;
        &:hover {
            background-color: var(--v-agorabg-base);
        }
        span.apexcharts-legend-text {
            display: flex;
        }
    }
}
@media screen and (max-width: $small) {
    .holdingsPieChart {
        padding: 0;
    }
}
</style>